export enum Tools {
  Circle = 'circle',
  Line = 'line',
  DashedLine = 'dashedline',
  Arrow = 'arrow',
  Pencil = 'pencil',
  Marker = 'marker',
  Eraser = 'eraser',
  Text = 'text',
  Rectangle = 'rectangle',
  Crop = 'crop',
  Triangle = 'triangle',
  Polygon = 'polygon',
  RectangleLabel = 'rectangle-label',
  Select = 'select',
  Pan = 'pan',
  Highlighter = 'highlighter',
  DefaultTool = 'default-tool',
  AddNote = 'addNote',
  Shapes = 'shapes',
  Trash = 'Trash',
  ZoomIn = 'ZoomIn',
  ZoomOut = 'ZoomOut',
}

export const isShapeTool = (tool: Tools): boolean => {
  return [
    Tools.Circle,
    Tools.Line,
    Tools.DashedLine,
    Tools.Arrow,
    Tools.Triangle,
    Tools.Polygon,
    Tools.Rectangle,
  ].includes(tool);
};

export default Tools;
